import UnsubscribeSuccess from ".";

export default function UnsubscribeSuccessExamples() {
  return <UnsubscribeSuccess onDoneClick={() => {}} />;
}
